import React from "react";
import {
    Card,
    CardHeader,
    Typography,
    Box,
    CardContent,
    Stack,
} from "@mui/material";

import ListItemMenu from "../../../Common/ListItemMenu";
import DevelopmentNeedStatusDetails from "./DevelopmentNeedStatusDetails";
import PORTAvatar from "../PORTAvatar";
import LinkButton from "../../../Common/Button/LinkButton";

function DevelopmentNeedCard({ developmentNeed, onDelete, onEdit }) {
    const title = developmentNeed?.title || "Development need";

    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                avatar={
                    <PORTAvatar
                        type={"developmentNeed"}
                        badge={!!developmentNeed.pdpId ? "attached" : ""}
                    />
                }
                action={
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                        sx={{ padding: "8px" }}
                    >
                        <ListItemMenu
                            onDelete={!!developmentNeed?.canDelete && onDelete}
                            onEdit={developmentNeed?.canUpdate && onEdit}
                        />
                        <LinkButton
                            to={`/portfolio/developmentneeds/${developmentNeed.id}`}
                        />
                    </Stack>
                }
                title={
                    <Typography component="h2" className="card-header-title">
                        {title}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        Development need
                    </Typography>
                }
            />

            <CardContent>
                <Box className="card-content">
                    <DevelopmentNeedStatusDetails
                        status={developmentNeed?.status}
                        dateCompletion={developmentNeed?.dateCompletion}
                        dateReview={developmentNeed?.dateReview}
                        dateEnd={developmentNeed?.dateEnd}
                    />
                </Box>
                <Box className="card-content">
                    <Typography variant="body1">
                        {developmentNeed?.description ?? ""}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
}

export default DevelopmentNeedCard;
